import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import RegulationTagsApi from '@/services/apiServiceModules/regulationTagsApi.js'
const regulationTagsApi = new RegulationTagsApi()

export default class RegulationTagsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.REGULATION_TAGS, regulationTagsApi, {
			useCache: true,
		})
	}
}
